import  { Button } from "@chr/eds-react";
import { useState, useEffect } from "react";
import { PermissionIds } from '@chr/online-shared-ui-constants';
import { checkAnyPermission } from '@/common/utilities/PermissionHelper';
import { useAppConfig } from "@/common/utilities/UseAppConfig";
import { useTranslation } from "@chr/online-shared-ui-localizations";

export const CallToActionButtons = () => {
    const [hasGAQPermissions, setGAQPermissions] = useState<boolean>();
    const [hasCreateOrderPermissions, setCreateOrderPermissions] = useState<boolean>();
    const { getAQuoteUrl, createOrderUrl } = useAppConfig();
    const translate = useTranslation();

    useEffect(() => {
        const gaqPermissions = [PermissionIds.GET_A_QUOTE];
        const createOrderPermissions = [PermissionIds.CREATE_ORDER];
        setGAQPermissions(checkAnyPermission(gaqPermissions));
        setCreateOrderPermissions(checkAnyPermission(createOrderPermissions));
    },[]);

    const handleCTA = async (url: string) => {
        window.location.assign(`${url}`);
    }
    // Function to get the CTA button based on the permission
    const getCTA = (permission: boolean | undefined, isPrimary: boolean, buttonText: string, id: string) => {
        if (permission) {
            const url = isPrimary ? getAQuoteUrl : createOrderUrl;
            return <Button id={id} buttonText={buttonText} variant="secondary" onClick={()=>{handleCTA(url)}} />;
        }
    }

    return (
        <>
            {getCTA(hasGAQPermissions, true, translate('Get a quote'), 'homepage-getAQuote-cta-button')}
            {getCTA(hasCreateOrderPermissions, false, translate('Create an order'), 'homepage-createOrder-cta-button')} 
        </>
    );
};







